import { FC } from 'react';

import { CurrencyConnected } from '@pp/core/src/components/currency/CurrencyConnected';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';

import styles from './CashedAndTotalBets.module.css';

interface TotalBetsProps {
  betCount: number | string | undefined;
  betAmount: number | string | undefined;
}

export const TotalBets: FC<TotalBetsProps> = ({ betCount = 0, betAmount = 0 }) => {
  return (
    <>
      <div className={styles.totalBets_container}>
        <div>
          <L10nText tk="STATISTICS_TOTAL_BETS" />:<span>&nbsp;</span>
        </div>
        <div>{betCount}</div>
      </div>
      <div className={styles.totalAmount}>
        <CurrencyConnected value={Number(betAmount)} />
      </div>
    </>
  );
};
